export function hasVersionsBeyondLayoutDraft(savedLayoutId: string | null | undefined, versionCount: number): boolean {
  const layoutDraftVersionCount = savedLayoutId ? 1 : 0;

  return versionCount > layoutDraftVersionCount;
}
